import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=0c16f73f&scoped=true"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=0c16f73f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16f73f",
  null
  
)

export default component.exports